/* eslint-disable max-len */
/* eslint-disable quote-props */
/* eslint-disable camelcase */

import _ from 'underscore';

/* istanbul ignore next */
const stringKeyMap = {
  'Import_AccountCurrencyConversion_Description': 'FacebookImport_AccountCurrencyConversion_Description',
  'Import_AccountCurrencyConversion_AccountLabel': 'FacebookImport_AccountCurrencyConversion_AccountLabel',
  'Import_AccountCurrencyConversion_BingAccountLabel': 'GoogleImport_AccountCurrencyConversion_BingAccountLabel',
  'Import_AccountCurrencyConversion_Tooltip': 'GoogleImport_AccountCurrencyConversion_Tooltip',
  'Import_AccountCurrencyConversion_Convert': 'GoogleImport_AccountCurrencyConversion_Convert',
  'Import_AccountCurrencyConversion_NotConvert': 'GoogleImport_AccountCurrencyConversion_NotConvert',

  // account step
  'Import_SelectAccount_AccountName': 'FacebookImport_SelectAccount_AccountName',
  'Import_SelectAccount_CurrencyName': 'GoogleImport_SelectAccount_CurrencyName',
  'Import_SelectAccount_CustomerId': 'FacebookImport_SelectAccount_CustomerId',
  'Import_SelectAccount_NoAccounts': 'GoogleImport_SelectAccount_NoAccounts',
  'Import_SelectAccount_NoActiveCampaigns': 'GoogleImport_SelectAccount_NoActiveCampaigns',
  'Import_SelectAccount_NoCampaigns': 'GoogleImport_SelectAccount_NoCampaigns',
  'Import_SelectAccount_Title': 'FacebookImport_SelectAccount_Title',
  'Import_SelectAccount_Summary': 'FacebookImport_SelectAccount_Summary',
  'Import_SelectAccount_NoAvailableAccounts': 'FacebookImport_SelectAccount_NoAvailableAccounts',

  // campaign step
  'Import_SelectCampaignsAndAdGroups_Title': 'FacebookImport_SelectCampaignsAndAdGroups_Title',
  'Import_SelectCampaign_Title': 'FacebookImport_SelectCampaign_Title',
  'Import_SelectCampaignsAndAdGroups_Summary': 'FacebookImport_SelectCampaignsAndAdGroups_Summary',
  'Import_SelectCampaign_Summary': 'FacebookImport_SelectCampaign_Summary',
  'Import_SelectCampaign_CampaignName': 'GoogleImport_SelectCampaign_CampaignName',
  'Import_SelectCampaign_Type': 'GoogleImport_SelectCampaign_Type',
  'Import_SelectCampaign_Status': 'GoogleImport_SelectCampaign_Status',
  'Import_Campaigns_ViewDetail_ColumnName': 'FacebookImport_Campaigns_ViewDetail_ColumnName',
  'Import_SelectCampaign_Description': 'FacebookImport_SelectCampaign_Description',
  'Import_SelectCampaign_ImportAll_ForSignUp': 'GoogleImport_SelectCampaign_ImportAll_ForSignUp',
  'Import_SelectCampaign_ImportAll': 'GoogleImport_SelectCampaign_ImportAll',
  'Import_SelectCampaign_ImportSpecific': 'GoogleImport_SelectCampaign_ImportSpecific',
  'Import_SelectCampaign_AllCampaigns': 'GoogleImport_SelectCampaign_AllCampaigns',
  'Import_SelectCampaign_AllPaused': 'GoogleImport_SelectCampaign_AllPaused',
  'Import_SelectCampaign_AllActive': 'GoogleImport_SelectCampaign_AllActive',

  'Import_Scheduled_Import_Throttling_Error': 'Google_Import_Scheduled_Import_Throttling_Error',

  // only needed for facebook
  'Import_ImportSummary_LoginSummary': 'FacebookImport_ImportSummary_LoginSummary',
  'Import_ImportSummary_AccountSummary': 'FacebookImport_ImportSummary_AccountSummary',
  'Import_ImportSummary_CampaignsAndAdGroupsSummary': 'FacebookImport_ImportSummary_CampaignsAndAdGroupsSummary',
  'Import_ImportSummary_CampaignSummary': 'FacebookImport_ImportSummary_CampaignSummary',

  // this is a facebook unique string
  'Import_SelectCampaign_Facebook_Id': 'FacebookImport_SelectCampaign_Facebook_Id',
  // this is facebook specific, override the string
  'Import_ImportOptions_SetMinBids_Generic': 'FacebookImport_ImportOptions_SetMinBids_Generic',
};

const getStateAdapter = (getState, patchState) => ({
  getState: (originalState) => {
    const state = originalState || getState();
    const {
      facebookAccountSummary,
      facebookAccount,
      facebookCampaigns,
      facebookCustomerId,
      initialSettings,
      facebookCampaignsSummary,
      facebookLoginSummary,
    } = state || {};
    const importContext = initialSettings ? initialSettings.FacebookImportContext : null;
    const entitiesBlobName = importContext ? importContext.FacebookEntitiesBlobName : null;
    return {
      ...state,
      importSourceAccountSummary: facebookAccountSummary,
      importSourceAccount: facebookAccount,
      importSourceCampaigns: facebookCampaigns,
      importSourceCustomerId: facebookCustomerId
            || (facebookAccount && facebookAccount.CustomerId)
            || (importContext && importContext.AccountId),
      importSourceCampaignsSummary: facebookCampaignsSummary,
      importSourceLoginSummary: facebookLoginSummary,
      importContext,
      entitiesBlobName,
    };
  },

  patchState: ({
    importSourceAccountSummary,
    importSourceAccount,
    importSourceCampaigns,
    importSourceCustomerId,
    importSourceEntitiesSelectionData,
    importSourceCampaignsSummary,
    importSourceLoginSummary,
    ...others
  }) => {
    const patch = others;
    if (!_.isUndefined(importSourceAccountSummary)) {
      patch.facebookAccountSummary = importSourceAccountSummary;
    }
    if (!_.isUndefined(importSourceAccount)) {
      patch.facebookAccount = importSourceAccount;
    }
    if (!_.isUndefined(importSourceCampaigns)) {
      patch.facebookCampaigns = importSourceCampaigns;
    }
    if (!_.isUndefined(importSourceCustomerId)) {
      patch.facebookCustomerId = importSourceCustomerId;
    }
    if (!_.isUndefined(importSourceEntitiesSelectionData)) {
      patch.facebookEntitiesSelectionData = importSourceEntitiesSelectionData;
    }
    if (!_.isUndefined(importSourceCampaignsSummary)) {
      patch.facebookCampaignsSummary = importSourceCampaignsSummary;
    }
    if (!_.isUndefined(importSourceLoginSummary)) {
      patch.facebookLoginSummary = importSourceLoginSummary;
    }
    return patchState(patch);
  },
});

const repoPropMapping = {
  getUserPreferences: 'getFacebookImportUserPreferences',
  prepareImportTaskItem: 'prepareFacebookImportTaskItem',
};

export const ImportSourceFacebook = {
  name: 'facebook',
  getI18nString: (i18n, originMethodName, key, args) => {
    if (!i18n || !i18n[originMethodName]) {
      return '';
    }
    if (stringKeyMap[key]) {
      return i18n[originMethodName].apply(i18n, [stringKeyMap[key], ...args]);
    }
    return i18n[originMethodName].apply(i18n, [key, ...args]);
  },
  getStateAdapter,
  repoPropMapping,
};
